import { inject, Injectable } from '@angular/core';
import { SubscriptionFeatureService } from '@rma/dashboard/billing/subscription-plans/public/api-subscription-features';
import { SubscriptionAccess } from '@rma/dashboard/generic/domain/to-be-sorted';
import { FeatureFlags, FeatureFlagService, TempFeatureFlags } from '@rma/dashboard/generic/util/feature-flags';
import { ExperienceCustomisationService } from '@rma/dashboard/layout/public/api-experience';
import { ConnectToGmbService } from '@rma/dashboard/linked-accounts/public/api-connect-gmb';
import { combineLatest, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SideNavigationConfigService {
  private readonly subscriptionFeatureService = inject(SubscriptionFeatureService);
  private readonly featuresService = inject(FeatureFlagService);
  private readonly connectToGmbService = inject(ConnectToGmbService);
  private readonly experienceCustomisationService = inject(ExperienceCustomisationService);

  public readonly showSocialStudioLink$ = this.experienceCustomisationService.showSocialStudioLink$;
  public readonly showSocialMediaManager$ = this.experienceCustomisationService.showSocialMediaManager$;
  public readonly showNps$ = this.experienceCustomisationService.showNps$;
  public readonly showGoogle$ = this.experienceCustomisationService.showGoogle$;
  public readonly showPromoter$ = this.experienceCustomisationService.showPromoter$;
  public readonly showReviewLinks$ = this.experienceCustomisationService.showReviewLinks$;
  public readonly showBillingAndSubs$ = this.experienceCustomisationService.showBillingAndSubs$;
  public readonly getMarketReportConfig$ = this.experienceCustomisationService.getMarketReportConfig$;

  public readonly getGoogleConfig$ = combineLatest({
    hasConnectedGmb: this.connectToGmbService.getConnectToGmbSettings().pipe(map((x) => (x?.hasSignedIn && x?.enabled) || false)),
    hasGoogleConnect: this.getSubscriptionAccess('HasGoogleConnect'),
    hasOwnGoogleAskForReviews: this.getSubscriptionAccess('HasOwnGoogleAskForReviews'),
    hasGoogleAskForReviews: this.getSubscriptionAccess('HasGoogleAskForReviews'),
  });

  public getSubscriptionAccess(access: SubscriptionAccess) {
    return this.subscriptionFeatureService.hasAccess(access);
  }

  public getFeature<T = boolean>(feature: FeatureFlags | TempFeatureFlags, defaultValue: T): Observable<T> {
    return this.featuresService.getFeature$<T>(feature, defaultValue);
  }

  public getLiveFeature<T = boolean>(feature: FeatureFlags | TempFeatureFlags, defaultValue: T): Observable<T> {
    return this.featuresService.getLiveFeature$<T>(feature, defaultValue);
  }
}
